module.exports = __webpack_public_path__ + "img/30m5.827abaf0.jpg";